import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-144c8565"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mailListItem" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "username wordHidden" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = ["src", "onError"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "username wordHidden" }

import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { getFirstXLetters } from '@/utils/format'
import Tooltip from "@/components/common/tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'mailListItem',
  props: {
    item: {
        type: Object,
        required: true
    },
    showLabel: {
        type: Boolean,
        default: true
    },
    sortByTime: {
        type: Boolean,
        default: false
    },
    isGeneral: {
        type: Boolean,
        default: false
    },
},
  emits: ["clickMailItem"],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;
onMounted(() => {
    document.onkeydown = (e) => {
        console.log('键盘按下了------------------------', e);
        if (e.key == 'ArrowDown') {
            // handleMailItemClick()
        }
    };
    if (!props.isGeneral) {
        const bottomDomList = document.querySelectorAll('.bottom') as any
        bottomDomList[0].classList.add('active')
    }
})
const isShowMore750 = computed(() => store.state.isShowMore750);
const store = useStore()
const handleMailItemClick = (e: any, i: any) => {
    console.log("eeeiiii:", e, i);

    const bottomDomList = document.querySelectorAll('.bottom') as any
    // 先移除所有item的active类名
    bottomDomList.forEach((item: any) => {
        item.classList.remove('active')
    })

    if (Array.from(e.target.classList).includes('username') || Array.from(e.target.classList).includes('avatar')) {
        e.target.parentNode.classList.add('active')
    } else if (Array.from(e.target.classList).includes('text') || Array.from(e.target.classList).includes('contentnowrap')) {
        e.target.parentNode.parentNode.classList.add('active')
    } else {
        // 再给当前点击项加上active类名
        e.target.classList.add('active')
    }
    console.log("e.target:", e.target);

    emit("clickMailItem");
    store.commit('setClickMailItemDetail', i)
}

const leftMailActiveIndex = ref(0)
const leftMailActiveItem = ref()
// const handleMailItemClick = (item: any, index: any) => {
const errImg = (data: any) => {
    console.log("图片展示不出来");
    data.showName = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showLabel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["top", isShowMore750.value ? '' : 'mobileTop'])
        }, _toDisplayString(__props.item.label), 3))
      : _createCommentVNode("", true),
    (__props.sortByTime)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bottom hoverStyle",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleMailItemClick($event, __props.item)))
        }, [
          (!__props.isGeneral || !__props.item.profile_picture_url)
            ? (_openBlock(), _createBlock(_component_el_avatar, {
                key: 0,
                class: "avatar"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getFirstXLetters)(__props.item.name, 3) || '--'), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_avatar, {
                key: 1,
                class: "avatar"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (!__props.item.showName)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: __props.item.profile_picture_url,
                          style: {"width":"40px","height":"40px"},
                          onError: _cache[0] || (_cache[0] = ($event: any) => (errImg(__props.item)))
                        }, null, 40, _hoisted_4))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getFirstXLetters)(__props.item.name, 3) || '--'), 1))
                  ])
                ]),
                _: 1
              })),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Tooltip, {
              content: __props.item.name || '--'
            }, null, 8, ["content"])
          ])
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(__props.item.children, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "bottom hoverStyle",
            key: index,
            onClick: ($event: any) => (handleMailItemClick($event, i))
          }, [
            (!__props.isGeneral || !i.profile_picture_url)
              ? (_openBlock(), _createBlock(_component_el_avatar, {
                  key: 0,
                  class: "avatar"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getFirstXLetters)(i.name, 3) || '--'), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_el_avatar, {
                  key: 1,
                  class: "avatar"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (!i.showName)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: i.profile_picture_url,
                            style: {"width":"40px","height":"40px"},
                            onError: ($event: any) => (errImg(i))
                          }, null, 40, _hoisted_10))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(getFirstXLetters)(i.name, 3) || '--'), 1))
                    ])
                  ]),
                  _: 2
                }, 1024)),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(Tooltip, {
                content: i.name || '--'
              }, null, 8, ["content"])
            ])
          ], 8, _hoisted_7))
        }), 128))
  ]))
}
}

})